import styled, { css } from 'styled-components';
import { tokens, media } from '../../../../../design/tokens';
import {
  HeaderColumnItemStyles,
  HeaderColumnWrapperItemStyles,
  HeaderTitleItemStyles,
} from '../../types';

export const Container = styled.section`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: ${tokens.space.xl};
  flex-direction: column;
`;

export const ContainerItem = styled.article`
  display: flex;
  padding: ${tokens.space.lg};
  width: 100%;
  border-radius: ${tokens.radius.sm};
  background-color: ${tokens.color.cardCharcoal};
  flex-direction: column;
  max-width: 1280px;
  box-shadow: ${tokens.shadow.imageSeat};
`;

export const HeaderItem = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  ${media.upTo(tokens.breakpoint.sm)} {
    flex-direction: column;
  }
`;

export const HeaderColumnItem = styled.div<HeaderColumnItemStyles>`
  ${({ justify }) => css`
    width: 100%;
    display: flex;
    justify-content: ${justify ? 'flex-' + justify : 'flex-start'};
    gap: ${tokens.space.lg};
  `}
`;

export const HeaderColumnWrapperItem = styled.div<HeaderColumnWrapperItemStyles>`
  ${({ align }) => css`
    width: 100%;
    height: 100%;
    display: flex;
    gap: ${tokens.space.lg};
    padding: ${tokens.space.sm};
    flex-direction: column;
    justify-content: space-between;
    align-items: ${align ? 'flex-' + align : 'flex-start'};

    ${media.upTo(tokens.breakpoint.sm)} {
      flex-direction: row;
    }
  `}
`;

export const HeaderTitleItem = styled.p<HeaderTitleItemStyles>`
  font-family: ${tokens.font.body.family};
  font-size: ${tokens.font.body.size};
  font-weight: 700;
  color: ${tokens.color.textWhite};
  margin: 0;

  ${({ total }) =>
    total &&
    css`
      color: ${tokens.color.marqueeGold};
    `}
`;

export const HeaderTextItem = styled.p`
  font-family: ${tokens.font.body.family};
  font-size: ${tokens.font.body.size};
  font-weight: 600;
  color: ${tokens.color.textWhite};
  margin: 0;
`;

export const TransactionId = styled.span`
  text-decoration: underline;
  text-decoration-color: ${tokens.color.fieldSlate};
`;

export const HeaderTextDetailItem = styled.span`
  color: ${tokens.color.textMist};
  text-decoration: underline;
  cursor: pointer;
  font-family: ${tokens.font.caption.family};
  font-size: ${tokens.font.caption.size};
  transition: color ${tokens.motion.quick};

  &:hover {
    color: ${tokens.color.marqueeGold};
  }
`;

export const DividerItem = styled.hr`
  margin: ${tokens.space.lg} 0;
  width: 100%;
  height: 2px;
  border: none;
  background-color: ${tokens.color.fieldSlate};
  opacity: 0.3;
`;

export const CanceledTagItem = styled.div`
  background-color: ${tokens.color.errorRed};
  padding: ${tokens.space.sm} ${tokens.space.md};
  border-radius: ${tokens.radius.pill};

  p {
    color: ${tokens.color.textWhite};
    margin: 0;
    font-size: ${tokens.font.caption.size};
    font-weight: 600;
  }
`;
